"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var group_svg_1 = __importDefault(require("../../../assets/icons/usuarios/group.svg"));
var manage_accounts_svg_1 = __importDefault(require("../../../assets/icons/usuarios/manage_accounts.svg"));
var person_svg_1 = __importDefault(require("../../../assets/icons/usuarios/person.svg"));
var person_add_svg_1 = __importDefault(require("../../../assets/icons/usuarios/person_add.svg"));
var person_alert_svg_1 = __importDefault(require("../../../assets/icons/usuarios/person_alert.svg"));
var person_cancel_svg_1 = __importDefault(require("../../../assets/icons/usuarios/person_cancel.svg"));
var person_check_svg_1 = __importDefault(require("../../../assets/icons/usuarios/person_check.svg"));
var person_edit_svg_1 = __importDefault(require("../../../assets/icons/usuarios/person_edit.svg"));
var person_remove_svg_1 = __importDefault(require("../../../assets/icons/usuarios/person_remove.svg"));
var person_search_svg_1 = __importDefault(require("../../../assets/icons/usuarios/person_search.svg"));
var group_add_svg_1 = __importDefault(require("../../../assets/icons/usuarios/group_add.svg"));
var person_off_svg_1 = __importDefault(require("../../../assets/icons/usuarios/person_off.svg"));
var Usuarios = {
    "group_add": group_add_svg_1.default,
    "person_off": person_off_svg_1.default,
    "group": group_svg_1.default,
    "manage_accounts": manage_accounts_svg_1.default,
    "person": person_svg_1.default,
    "person_add": person_add_svg_1.default,
    "person_alert": person_alert_svg_1.default,
    "person_cancel": person_cancel_svg_1.default,
    "person_check": person_check_svg_1.default,
    "person_edit": person_edit_svg_1.default,
    "person_remove": person_remove_svg_1.default,
    "person_search": person_search_svg_1.default,
};
exports.default = Usuarios;
